<template>
  <v-dialog v-model="dialog" width="400px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text v-if="textWarning.length" style="color: red">
        {{ textWarning }}
      </v-card-text>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pb-5 px-6">
        <v-btn color="primary" class="pa-2" @click="cancel" outlined>{{ cacelText }}</v-btn>
        <v-btn :color="okBtnColor" width="100px" class="elevation-0" @click="ok">{{ okText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {},
  props: {
    state: Boolean,
    title: String,
    message: String,
    textWarning: {
      type: String,
      default: ''
    },
    cacelText: {
      type: String,
      default: 'Hủy'
    },
    okText: {
      type: String,
      default: 'Xác nhận'
    },
    okBtnColor: {
      type: String,
      enum: ['primary', 'error', 'warning'],
      default: 'primary'
    }
  },
  data() {
    return {
      dialog: false,
      data: {}
    }
  },
  methods: {
    openDialog(data) {
      this.dialog = true
      this.data = data
    },
    async ok() {
      this.$emit('ok', this.data)
      this.dialog = false
    },
    cancel() {
      this.$emit('cancel')
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
